import React, { useState, useEffect } from "react";
import Carousel from "react-multi-carousel";
import { Link } from "react-router-dom";
import "react-multi-carousel/lib/styles.css";
import { useSelector } from "react-redux";
import { useTheme } from "../context/ThemeContext";

const CustomDot = ({ onClick, active }) => (
  <button
    onClick={onClick}
    type="button"
    aria-label={active ? "Slide activo" : "Ir a slide"}
    className={`
      h-[3px] rounded-full mx-[3px] transition-all duration-500 ease-in-out focus:outline-none
      ${ active
        ? "w-6 bg-gray-700 shadow-sm"
        : "w-[10px] bg-gray-300 hover:bg-gray-400"
      }
    `}
  />
);

const Brands = () => {
  const { brands } = useSelector(state => state.home);
  const [isMobile, setIsMobile] = useState(false);
  const filteredBrands = brands.filter(c => c.verpublishbrand === true && c.image && c.image.trim() !== "");

  const { getBackground } = useTheme();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1025 },
      items: Math.min(filteredBrands.length, 8),
    },
    tablet: {
      breakpoint: { max: 1024, min: 641 },
      items: Math.min(filteredBrands.length, 4),
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: Math.min(filteredBrands.length, 2),
    },
  };

  if (filteredBrands.length === 0) {
    return null;
  }

  return (
    <div style={{ ...getBackground("backgroundBrand") }}>
      <div className="w-[100%] lg:w-[100%] md:w-[100%] sm:w-full mx-auto relative px-20 lg:px-20 md:px-6 sm:px-0">
        <div className="relative max-w-full overflow-hidden px-0">
          <Carousel
            autoPlay={true}
            infinite={true}
            arrows={!isMobile}
            responsive={responsive}
            transitionDuration={500}
            containerClass="!overflow-visible"
            itemClass="px-1"
            additionalTransfrom={0}
            showDots={isMobile}
            dotListClass="flex justify-center items-center gap-0 mt-1 pb-1"
            renderDotsOutside={isMobile}
            customDot={<CustomDot />}
            customLeftArrow={
              <button className="absolute left-2 top-1/2 -translate-y-1/2 z-10 bg-white border border-gray-300 rounded-full w-10 h-10 flex items-center justify-center shadow-md hover:shadow-lg transition-shadow hover:bg-gray-50">
                <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
              </button>
            }
            customRightArrow={
              <button className="absolute right-2 top-1/2 -translate-y-1/2 z-50 bg-white border border-gray-300 rounded-full w-10 h-10 flex items-center justify-center shadow-md hover:shadow-lg transition-shadow hover:bg-gray-50">
                <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </button>
            }>
            {filteredBrands.map((c, i) => (
              <Link key={i} to={`/products/search?brand=${encodeURIComponent(c.name)}`} className="block w-full h-full">
                <div className="w-full h-[120px] flex items-center justify-center p-1">
                  <div className="w-full h-full flex items-center justify-center p-1">
                    <img
                      src={c.image}
                      alt={c.name}
                      className="w-auto h-auto max-w-full max-h-full object-contain"
                      onError={e => {
                        e.target.style.display = "none";
                      }}
                    />
                  </div>
                </div>
              </Link>
            ))}
          </Carousel>
        </div>
      </div>
    </div>
  );
};

export default Brands;
